import React, { useState } from "react";
import Switch from "react-bootstrap-switch";
import { connect } from "react-redux";
import { useForm } from "react-hook-form";


// components
import { ButtonClean, ButtonSearch } from "../../../components/buttons/buttonsActions";


// actions
import { setFilter } from "../../../redux/actions/generalActions/listActions";
import { CardBody, Col, Form, FormGroup, Input, Label, Row } from "reactstrap";
import {
    FL_CODE,
    FL_END_DATE,
    FL_START_DATE, FL_STATUS,
} from "../../../components/i18n/formLabels";

const CampaignFilters = props => {
    const { filter } = props.listProps
    const { app } = props.mainProps

    const fbDataBaseId = app?.fbDataBase?.id
    const [status, setStatus] = useState( filter?.item?.status ?? null);

    // ----------------------------------------------
    //            CHANGE HANDLERS
    // ----------------------------------------------
    const statusChange = () => {
        setStatus(!status);
    };

    const cleanFields = () => {
        const tmpFilter = JSON.parse(JSON.stringify(filter))

        setStatus(null);

        reset({
            code: '',
            startDate: '',
            endDate: ''
        });

        if(tmpFilter && tmpFilter.item){
            delete tmpFilter.item.code;
            delete tmpFilter.item.startDate;
            delete tmpFilter.item.endDate;
        }

        props.setFilter(tmpFilter);
    }

    // ----------------------------------------------
    //            SEARCH FILTERS FORM
    // ----------------------------------------------
    const {register, handleSubmit, reset} = useForm({
        defaultValues: {
            code: filter?.item?.code,
            startDate: filter?.item?.startDate,
            endDate: filter?.item?.endDate
        }
    });

    const onSubmit = (data, _) => {
        if(!fbDataBaseId)
            return

        const dataFilter = {
            onlyRegistered : true,
            fbDataBase : {  id : fbDataBaseId },
            item : { ...data }
        }

        if (status !== undefined && status !== null)
            dataFilter.item.status = status;


        props.setFilter(dataFilter);
    };

    return <Form onSubmit={handleSubmit(onSubmit)}>
        <CardBody className="">
            <Row>
                <Col md="3">
                    <FormGroup>
                        <Label>{ FL_CODE }</Label>
                        <Input
                            type="text"
                            name="code"
                            placeholder={ FL_CODE }
                            innerRef={register}
                        />
                    </FormGroup>
                </Col>
                <Col md="3">
                    <FormGroup>
                        <Label>{ FL_START_DATE }</Label>
                        <Input
                            type="date"
                            name="startDate"
                            placeholder={ FL_START_DATE }
                            innerRef={register}
                        />
                    </FormGroup>
                </Col>
                <Col md="3">
                    <FormGroup>
                        <Label>{ FL_END_DATE }</Label>
                        <Input
                            type="date"
                            name="endDate"
                            placeholder={ FL_END_DATE }
                            innerRef={register}
                        />
                    </FormGroup>
                </Col>
                <Col md="2">
                    <FormGroup>
                        <Label>{ FL_STATUS }</Label>
                        <br />
                        <Switch
                            animate={true}
                            offText={"No"}
                            onText={"Si"}
                            value={status}
                            innerRef={register}
                            onChange={statusChange}
                        />
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col md="12" className="d-flex justify-content-center">
                    <div className="float-right">
                        <ButtonSearch/>
                        <ButtonClean onClick={() => cleanFields()}/>
                    </div>
                </Col>
            </Row>
        </CardBody>
    </Form>
}

const mapStateToProps = state => ({
    mainProps: state.mainProps,
    formProps: state.formProps,
    listProps: state.listProps,
})

const mapActionsToProps = ({
    setFilter,
})

export default connect(mapStateToProps, mapActionsToProps)(CampaignFilters)